import { ProjectActions } from "../../reducers/project/actionsNames";
import { Category, IAttributes, IProject } from "../../reducers/project";

export default (project: IProject) => ({
  type: ProjectActions.AddProjectToCart,
  project,
});
